import React from "react"
import { withTranslation, WithTranslation, Trans } from "react-i18next"
import { observer, inject } from "mobx-react"
import Store from "../stores/Store"
import { BookingItem } from "../records/Booking"
import Hidden from "@material-ui/core/Hidden"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableHead from "@material-ui/core/TableHead"
import TableFooter from "@material-ui/core/TableFooter"
import TableRow from "@material-ui/core/TableRow"
import Typography from "@material-ui/core/Typography"
import NumberInput from "./NumberInput"

interface SearchResultsProps extends WithTranslation {
    store?: Store
}

@inject("store")
@observer
class SearchResults extends React.Component<SearchResultsProps> {
    selectAction = (selected: boolean, item: BookingItem) => {
        if (selected) {
            this.props.store!.addToSelectedRooms(item)
        } else {
            this.props.store!.removeFromSelectedRooms(item)
        }
    }

    render () {
        return (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{this.props.t("Room")}</TableCell>
                        <TableCell align="right">{this.props.t("Beds")}</TableCell>
                        <TableCell align="right">{this.props.t("Price")}</TableCell>
                        <TableCell align="right">{this.props.t("Select rooms")}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.props.store!.rooms.length === 0 &&
                            <TableRow>
                                <TableCell component="th" scope="row" colSpan={4} align="center">
                                    {this.props.t("No rooms, change search parameters.")}
                                </TableCell>
                            </TableRow>
                    }
                    {this.props.store!.rooms.map((item: BookingItem) => (
                        <TableRow key={item.id} className={this.props.store!.selectedRooms.indexOf(item) !== -1 ? "App-booking-item-selected" : ""}>
                            <TableCell>{item.name}</TableCell>
                            <TableCell align="right">{item.beds}</TableCell>
                            <TableCell align="right">{item.price.toFixed(2)}&nbsp;€</TableCell>
                            <TableCell align="right">
                                <NumberInput
                                    minLimit={0}
                                    maxLimit={1}
                                    value={this.props.store!.selectedRooms.indexOf(item) !== -1 ? 1 : 0}
                                    onChange={(newValue: number) => {
                                        this.selectAction(!!newValue, item)
                                    }}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TableCell>
                            <Typography variant="h6">
                                {this.props.t("Total")}
                            </Typography>
                        </TableCell>
                        <TableCell align="right">
                            <Hidden xsDown>
                                <Typography variant="h6">
                                    {this.props.store!.totalBeds}
                                </Typography>
                            </Hidden>
                        </TableCell>
                        <TableCell align="right" className="App-booking-item-price">
                            <Typography variant="h6">
                                {this.props.store!.sumPrice.toFixed(2)}&nbsp;€
                            </Typography>
                        </TableCell>
                        <TableCell align="right">
                            <Typography variant="h6">
                                {this.props.store!.selectedRooms.length}
                            </Typography>
                        </TableCell>
                    </TableRow>
                    {this.props.store?.booking && (
                        <TableRow>
                            <TableCell colSpan={2}>
                                <Trans i18nKey="Payment" count={this.props.store!.feePercent}>
                                    Total payment to confirm reservation
                                </Trans>
                            </TableCell>
                            <TableCell align="right">{this.props.store!.payPrice.toFixed(2)}&nbsp;€</TableCell>
                            <TableCell align="right"></TableCell>
                        </TableRow>
                    )}
                </TableFooter>
            </Table>
        )
    }
}

export default withTranslation()(SearchResults)
